import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormStateEnum } from '@magieno/angular-advanced-forms';
import { Subscription } from 'rxjs';
import {
  RolloverSharesClassOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-shares-class.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rollover-share-class-form',
  templateUrl: './rollover-share-class-form.component.html',
  styleUrls: ['./rollover-share-class-form.component.scss'],
  standalone: false,
})
export class RolloverShareClassFormComponent implements OnInit, OnDestroy {

  @Input()
  shareClassForm: AdvancedFormGroup<RolloverSharesClassOptions>;

  @Input()
  index: number;

  @Input()
  form: AdvancedForm<RolloverOptions>;

  onIsRightToParticipateChangeSubscription: Subscription;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {

  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get isRightToParticipate(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.shareClassForm.formElements.isRightToParticipate as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isRightToVote(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.shareClassForm.formElements.isRightToVote as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get redemptionValue(): AdvancedFormControl<number, number, number> {
    return this.shareClassForm.formElements.redemptionValue as AdvancedFormControl<number, number, number>;
  }

  get title(): AdvancedFormControl<string, string, string> {
    return this.shareClassForm.formElements.title as AdvancedFormControl<string, string, string>;
  }

  ngOnInit() {
    this.onIsRightToParticipateChangeSubscription = this.isRightToParticipate.value$.subscribe((value) => {
      this.handleRedemptionValueVisibility();
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.onIsRightToParticipateChangeSubscription?.unsubscribe();
  }

  ngAfterViewInit() {
    this.refresh();
  }

  refresh() {
    this.handleRedemptionValueVisibility();
    this.changeDetectorRef.detectChanges();
  }

  handleRedemptionValueVisibility() {
    if (this.shareClassForm.value.isRightToParticipate === false) {
      this.enableRedemptionValue();
    } else {
      this.disableRedemptionValue();
    }
  }

  disableRedemptionValue() {
    this.redemptionValue.disable();
    this.redemptionValue.setValue(undefined);
    this.redemptionValue.state = FormStateEnum.Valid;
  }

  enableRedemptionValue() {
    this.redemptionValue.enable();
  }

}
